import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import Select, { createFilter } from 'react-select';
import { useCookies } from 'react-cookie';
import SimpleValue from 'react-select-simple-value';
import { Button, Col, Row } from 'react-bootstrap';
import { Link, navigate } from "raviger";
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleT, faCircleC, faCircleW
} from '@fortawesome/pro-solid-svg-icons';
import { loadUser } from "./accounts/AccountsUtils";
import { AuthContext } from "./accounts/AccountsReducer";
import { SystemErrorContext } from './components/SystemError';

function OrganizationManagement(organization) {

  const { dispatch, state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);

  const [options, setOptions] = useState([]);
  const [cookies, , removeCookie] = useCookies(['token']);

  const path = window.location.pathname;
  const org_slug = path.split('/')[1];


  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();;

    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [organization]);

  return (
    <>
    <Row className='ml-auto mr-auto mt-5 align-bottom'>
      <h1 style={{fontSize:"60px", textTransform: 'capitalize'}}>{state.organization.name} - Manage Organization</h1>
    </Row>
    <Col xs={{ span:5 }} className="border rounded border-light shadow-sm ml-auto mr-auto mb-auto" style={{minWidth:"572px"}}>    {state.user.is_superuser || state.user.user_perms ? 
      <>
        <Row>
            <Col style={{marginRight:"-23px"}}>
              <Link href={'/' + org_slug + '/manage/accounts'} style={{textDecoration:"none"}}><Button size="lg" className="btn-primary mt-3" block>User Management</Button></Link>
            </Col>
            <Col>
             <Link href={'/' + org_slug + '/manage/accounts/access_tokens'} style={{textDecoration:"none"}}><Button size="lg" className="btn-primary mt-3" block>Access Tokens</Button></Link>
            </Col>
        </Row>
        <Row>
            <Col>
              <Link href={`/${org_slug}/manage/shelters`} style={{textDecoration:"none"}}><Button size="lg" className="btn-primary mt-2" block>Manage Shelters</Button></Link>
            </Col>
        </Row>
        <Row>
            <Col>
              <Link href={`/${org_slug}/manage/organization/edit`} style={{textDecoration:"none"}}><Button size="lg" className="btn-primary mt-2" block>Edit Organization</Button></Link>
            </Col>
        </Row>
      </>
    : ""}
      <Link href={`/${org_slug}`} style={{textDecoration:"none"}}><Button size="lg" className="btn-primary mt-2 mb-3" block>Return to Incidents</Button></Link>
    </Col>
    </>
  );
}

export default OrganizationManagement;
